import { APP_VERSION_SHORT, APP_VERSION } from "../version";

const DISRUPTIVE_LOGO =
  "https://customer-assets.emergentagent.com/job_yolo-crop-counter/artifacts/qx3y7mcn_Recurso%202lgo%20disr.png";

/**
 * Reusable footer for protected pages.
 * Always shows the app version (single-source from src/version.js).
 *
 * Usage:
 *   <AppFooter />
 *   <AppFooter compact />     // tighter padding
 */
export default function AppFooter({ compact = false }) {
  return (
    <footer className={`mt-auto w-full border-t border-slate-800 bg-slate-900/80 ${compact ? 'py-2' : 'py-4'}`}>
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-3 px-4 text-center sm:grid-cols-[1fr_auto_1fr] sm:px-6 lg:px-8">
        <div className="flex min-w-0 items-center justify-center gap-2 sm:justify-start">
          <img src={DISRUPTIVE_LOGO} alt="Disruptive Software" className="h-6 w-auto shrink-0 invert sm:h-7" />
          <span
            className="hidden sm:inline-block text-[10px] font-mono px-2 py-0.5 rounded bg-slate-800/60 text-slate-400 border border-slate-700"
            title={APP_VERSION}
            data-testid="app-version-footer"
          >
            {APP_VERSION_SHORT}
          </span>
        </div>
        <span className="text-xs leading-relaxed text-slate-500">
          Desarrollado por{" "}
          <a
            href="https://www.disruptive-sw.com"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-white"
          >
            Disruptive Software
          </a>
          . Todos los derechos reservados.
        </span>
        <div className="flex min-w-0 items-center justify-center gap-2 sm:justify-end">
          <span
            className="sm:hidden text-[10px] font-mono px-2 py-0.5 rounded bg-slate-800/60 text-slate-400 border border-slate-700"
            title={APP_VERSION}
          >
            {APP_VERSION_SHORT}
          </span>
          <span className="min-w-0 truncate text-xs text-slate-500">
            <a href="mailto:info@disruptive-sw.com" className="hover:text-white">
              info@disruptive-sw.com
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
